import { render } from "./homeTeachResearch.vue?vue&type=template&id=667477a0&scoped=true"
import script from "./homeTeachResearch.vue?vue&type=script&lang=js"
export * from "./homeTeachResearch.vue?vue&type=script&lang=js"

import "./homeTeachResearch.vue?vue&type=style&index=0&id=667477a0&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667477a0"]])

export default __exports__